import React, { useState } from 'react';
import { 
  Box, Typography, IconButton, Menu, MenuItem, alpha,
  ToggleButton, ToggleButtonGroup, Tooltip, Button, 
  Divider
} from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import SortIcon from '@mui/icons-material/Sort';
import ViewListIcon from '@mui/icons-material/ViewList';
import GridViewIcon from '@mui/icons-material/GridView';
import PrintIcon from '@mui/icons-material/Print';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import DashboardCustomizeOutlinedIcon from '@mui/icons-material/DashboardCustomizeOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
// Hình dạng dùng CHUNG với thanh tiêu đề của InputBase — xem giaoDienDanhSach.js.
import { sxThanhTieuDe, sxTieuDe, sxVungCongCu, sxVachNgan, sxNutDangChon, sxNutXoaTieuDe, sxNhomCheDoXem, sxKhungMenu } from './giaoDienDanhSach';

export default function DataListHeader({ 
  title, 
  onBack, 
  sortOptions, 
  currentSort, 
  onSortChange, 
  headerRight,
  viewMode,         
  onViewModeChange,
  
  onPrint,          
  disablePrint,
  
  onDeleteMany,
  disableDeleteMany,

  onOpenOptions,     // Mở form tuỳ chọn (nếu có) — hiện nút bánh răng trên header
  optionsTooltip = 'Tuỳ chọn',

  onOpenConfig,      // Mở form CẤU HÌNH MÀN HÌNH (data_list_config) — chỉ quản trị mới được truyền
  onOpenGuide,       // Mở HƯỚNG DẪN của màn hình — chỉ truyền khi cấu hình có `guideFile`

  actionContent
}) {
  const [anchorEl, setAnchorEl] = useState(null);

  return (
    <Box sx={sxThanhTieuDe(alpha, { cheDoBang: viewMode == "table" })}>
      
      {/* 1. KHU VỰC TRÁI: TITLE & NÚT BACK */}
      <Box sx={{ display: 'flex', alignItems: 'center', overflow: 'hidden', pr: 2 }}>
        {onBack && (
          <Tooltip title="Quay lại" placement="bottom">
            <IconButton onClick={onBack} sx={{ color: 'inherit', mr: 0.5, p: 1 }}>
              <ArrowBackIosNewIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
        <Typography variant="h6" fontWeight="bold" noWrap sx={{ ...sxTieuDe, pl: onBack ? 0 : 1 }}>
          {title}
        </Typography>
      </Box>
      {/* 3. KHU VỰC PHẢI: CÔNG CỤ */}
      <Box sx={sxVungCongCu}>

        {/* 2. KHU VỰC GIỮA: THANH TÌM KIẾM (Đã giới hạn độ rộng để nằm gọn gàng) */}
        {actionContent && (
          <Box sx={{ display: 'flex', alignItems: 'center', width: { md: 350, lg: 350 } }}>
            {actionContent}
          </Box>
        )}

        {/* --- VẠCH NGĂN CÁCH (Chỉ hiện khi có thanh tìm kiếm ở chế độ PC) --- */}
        {actionContent && (
          <Divider 
            orientation="vertical" 
            flexItem 
 sx={sxVachNgan} 
          />
        )}
        
        {onDeleteMany && (
          <Tooltip title="Xoá các dòng đã chọn" placement="bottom">
            <span style={{ display: 'inline-flex' }}>
              <Button variant="outlined" onClick={onDeleteMany} disabled={disableDeleteMany} sx={!disableDeleteMany ? sxNutXoaTieuDe : {} }>
                <DeleteOutlineIcon fontSize="small" />
              </Button>
            </span>
          </Tooltip>
        )}

        {onPrint && (
          <Tooltip title="In ấn & nhập xuất dữ liệu" placement="bottom">
            <span style={{ display: 'inline-flex' }}>
              <Button variant="outlined" onClick={onPrint} disabled={disablePrint}>
                <PrintIcon fontSize="small" />
              </Button>
            </span>
          </Tooltip>
        )}

        {onViewModeChange && (
          <ToggleButtonGroup size="small" value={viewMode || 'card'} exclusive onChange={(e, newVal) => { if (newVal) onViewModeChange(newVal); }} sx={sxNhomCheDoXem}>
            <Tooltip title="Dạng bảng" placement="bottom"><ToggleButton value="table"><ViewListIcon fontSize="small" /></ToggleButton></Tooltip>
            <Tooltip title="Dạng lưới" placement="bottom"><ToggleButton value="card"><GridViewIcon fontSize="small" /></ToggleButton></Tooltip>
          </ToggleButtonGroup>
        )}

        {headerRight && headerRight}

        {onOpenOptions && (
          <Tooltip title={optionsTooltip} placement="bottom">
            <IconButton onClick={onOpenOptions}>
              <SettingsOutlinedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}

        {onOpenGuide && (
          <Tooltip title="Hướng dẫn" placement="bottom">
            <IconButton onClick={onOpenGuide} aria-label="Hướng dẫn">
              <MenuBookOutlinedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}

        {onOpenConfig && (
          <Tooltip title="Cấu hình màn hình (cột, bộ lọc, tìm kiếm, tab…)" placement="bottom">
            <IconButton onClick={onOpenConfig}>
              <DashboardCustomizeOutlinedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}

        {sortOptions && sortOptions.length > 0 && (
          <Box>
            <Tooltip title="Sắp xếp" placement="bottom">
              <IconButton onClick={(e) => setAnchorEl(e.currentTarget)} sx={currentSort ? sxNutDangChon : {}}>
                <SortIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)} PaperProps={{ sx: sxKhungMenu }}>
              {sortOptions.map((opt, index) => (<MenuItem key={index} onClick={() => { onSortChange(opt); setAnchorEl(null); }} selected={currentSort?.label === opt.label} sx={{ fontWeight: currentSort?.label === opt.label ? 'bold' : 'normal', color: currentSort?.label === opt.label ? 'primary.main' : 'inherit' }}>{opt.label}</MenuItem>))}
            </Menu>
          </Box>
        )}
      </Box>
    </Box>
  );
}